
import React from "react"
import App from "./App.js"
import reactDOM from "react-dom"

reactDOM.render(<App/>,document.getElementById("root"))